import { memo } from "react";
import PaymentDrawTonightContent from "./layout/PaymentDrawTonightContent";
import usePaymentDrawTonightProvider from "./hooks/provider";

const PaymentDrawTonight: React.FC = (): JSX.Element => {
  usePaymentDrawTonightProvider();

  return <PaymentDrawTonightContent />;
};

export default memo(PaymentDrawTonight);
